import { DataTable } from '@/components/ui/DataTable'
import { useRestClient } from '@/contexts/QueryProvider'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { useCurrentApplication } from '../useCurrentApplication'
import { Button } from '@/components/shadcn/button'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Suspense } from 'react'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { appPagesTableColumnsV2 } from './AppPagesTable/appPagesTableColumnsV2'
import PageForm from '../Forms/PageForm'

export const AppPagesPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Pages" />
      <QueryErrorBoundary errorMessage="Failed to fetch pages">
        <Suspense fallback={<DataTableLoading />}>
          <AppPagesPanelContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function AppPagesPanelContent() {
  const { applicationId } = useCurrentApplication()
  const { getAppPagesApiGetApplicationPages } = useRestClient()

  const { data } = getAppPagesApiGetApplicationPages.useSuspenseQuery({ query: { applicationId } })

  return (
    <TablePageContainer>
      <DataTable
        columns={appPagesTableColumnsV2}
        data={data.items ?? []}
        action={
          <PageForm
            sheetTitle="Add a page"
            sheetTrigger={
              <Button size="sm" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add page
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
